var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeMerchSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-gift",
    "data-name": "Icon ionic-ios-gift",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.964,
    height: 41.961,
    viewBox: "0 0 38.964 41.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M39.342,11.991h-7.9a5.5,5.5,0,0,0,1.9-4.121,5.776,5.776,0,0,0-5.91-5.62,5.226,5.226,0,0,0-4.58,2.566,5.226,5.226,0,0,0-4.58-2.566,5.776,5.776,0,0,0-5.91,5.62,5.471,5.471,0,0,0,1.9,4.121h-7.9a2.994,2.994,0,0,0-3,3v1.873a.376.376,0,0,0,.375.375H41.965a.376.376,0,0,0,.375-.375V14.988A2.994,2.994,0,0,0,39.342,11.991Zm-11.9-7.118a3.079,3.079,0,0,1,3.156,3,3.079,3.079,0,0,1-3.156,3H24.281C24.281,6.371,25.7,4.873,27.437,4.873Zm-9.16,0c1.742,0,3.156,1.5,3.156,5.994H18.277a3.079,3.079,0,0,1-3.156-3A3.079,3.079,0,0,1,18.277,4.873Z",
    transform: "translate(-3.375 -2.25)",
    fill: "#fed700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M4.5,16.077V36.871a3.006,3.006,0,0,0,3,3H21.172V15.328H5.249A.752.752,0,0,0,4.5,16.077Z",
    transform: "translate(-3.001 2.093)",
    fill: "#fed700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M34.907,15.328H18.984v24.54H32.659a3.006,3.006,0,0,0,3-3V16.077A.752.752,0,0,0,34.907,15.328Z",
    transform: "translate(1.809 2.093)",
    fill: "#fed700"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeMerchSelected);
export default __webpack_public_path__ + "static/media/freeMerchSelected.cdb95a6145268c47f86e63847b03175e.svg";
export { ForwardRef as ReactComponent };